export default function Waveform({ bars = 24, height = 48 }) {
  return (
    <div className="d-flex align-items-end gap-1" style={{ height }}>
      {Array.from({ length: bars }).map((_, i) => (
        <div
          key={i}
          className="wave-bar"
          style={{
            width: 4,
            height: '100%',
            background: i % 5 === 0 ? 'var(--cpuc-black)' : 'var(--cpuc-red)',
            opacity: i % 5 === 0 ? 0.3 : 1,
            animationDelay: `${(i % 8) * 0.09}s`,
          }}
        />
      ))}
    </div>
  );
}
